export const iconFontAwesomeTextformattingSpellCheck = (
	<i className="fa-solid fa-spell-check"></i>
);
